import { render, staticRenderFns } from "./OrderIndex.vue?vue&type=template&id=1b3cbee8&"
import script from "./OrderIndex.vue?vue&type=script&lang=ts&"
export * from "./OrderIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports